import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme, THEMES } from '../context/ThemeContext';
import './Header.css';

function Header() {
  const { theme, setTheme } = useTheme();

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <span className="logo-icon">&#9670;</span>
          <span className="logo-text">Demo<span className="logo-accent">Hub</span></span>
        </Link>

        <div className="theme-switcher">
          {Object.keys(THEMES).map((key) => (
            <button
              key={key}
              className={`theme-btn ${theme === key ? 'active' : ''} theme-${key}`}
              onClick={() => setTheme(key)}
              title={THEMES[key].name}
            >
              <span className="theme-indicator"></span>
              <span className="theme-label">{THEMES[key].name}</span>
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}

export default Header;
